/**
 * GENERATED by scripts/gen-theme.mjs from LaunchPad/ideas/_design.md — do not edit by hand.
 *
 * CommonJS because tailwind.config.js reads it; the .d.ts beside it is what useLayout.ts reads.
 * Everything here is a token the design file owns: the six type steps in px, the radius ladder
 * derived from one --radius, the two layout breakpoints, and the colour roles pointed at the CSS
 * variables in global.css.
 */
module.exports = {
  "accentHue": 132,
  "fontFamily": {
    "sans": [
      "Figtree",
      "Segoe UI",
      "system-ui",
      "-apple-system",
      "sans-serif"
    ],
    "serif": [
      "Iowan Old Style",
      "Palatino Linotype",
      "Georgia",
      "serif"
    ],
    "mono": [
      "JetBrains Mono",
      "Consolas",
      "ui-monospace",
      "monospace"
    ],
    "display": [
      "Fraunces",
      "Georgia",
      "Times New Roman",
      "serif"
    ]
  },
  "fontSize": {
    "display": [
      "34px",
      {
        "lineHeight": "40px",
        "letterSpacing": "-0.68px",
        "fontWeight": "600"
      }
    ],
    "title": [
      "24px",
      {
        "lineHeight": "30px",
        "letterSpacing": "-0.36px",
        "fontWeight": "600"
      }
    ],
    "heading": [
      "18px",
      {
        "lineHeight": "25px",
        "letterSpacing": "-0.18px",
        "fontWeight": "600"
      }
    ],
    "body": [
      "15px",
      {
        "lineHeight": "22px",
        "letterSpacing": "0px",
        "fontWeight": "400"
      }
    ],
    "small": [
      "13px",
      {
        "lineHeight": "19px",
        "letterSpacing": "0px",
        "fontWeight": "400"
      }
    ],
    "caption": [
      "11.5px",
      {
        "lineHeight": "16px",
        "letterSpacing": "0.632px",
        "fontWeight": "600"
      }
    ]
  },
  "borderRadius": {
    "sm": "6px",
    "md": "8px",
    "lg": "10px",
    "xl": "14px"
  },
  "screens": {
    "wide": "900px",
    "expanded": "1200px"
  },
  "breakpoints": {
    "wide": 900,
    "expanded": 1200
  },
  "colors": {
    "background": "hsl(var(--background))",
    "foreground": "hsl(var(--foreground))",
    "card": {
      "DEFAULT": "hsl(var(--card))",
      "foreground": "hsl(var(--card-foreground))"
    },
    "popover": {
      "DEFAULT": "hsl(var(--popover))",
      "foreground": "hsl(var(--popover-foreground))"
    },
    "primary": {
      "DEFAULT": "hsl(var(--primary))",
      "foreground": "hsl(var(--primary-foreground))"
    },
    "secondary": {
      "DEFAULT": "hsl(var(--secondary))",
      "foreground": "hsl(var(--secondary-foreground))"
    },
    "muted": {
      "DEFAULT": "hsl(var(--muted))",
      "foreground": "hsl(var(--muted-foreground))"
    },
    "accent": {
      "DEFAULT": "hsl(var(--accent))",
      "foreground": "hsl(var(--accent-foreground))"
    },
    "destructive": {
      "DEFAULT": "hsl(var(--destructive))",
      "foreground": "hsl(var(--destructive-foreground))"
    },
    "border": "hsl(var(--border))",
    "input": "hsl(var(--input))",
    "ring": "hsl(var(--ring))",
    "success": "hsl(var(--success))",
    "warning": "hsl(var(--warning))",
    "gradient-from": "hsl(var(--gradient-from))",
    "gradient-to": "hsl(var(--gradient-to))",
    "card-2": "hsl(var(--card-2))",
    "secondary-line": "hsl(var(--secondary-line))",
    "line-strong": "hsl(var(--line-strong))",
    "band-top": "hsl(var(--band-top))",
    "band-foot": "hsl(var(--band-foot))",
    "band-ink": "hsl(var(--band-ink))",
    "band-rule": "hsl(var(--band-rule))",
    "gold": "hsl(var(--gold))",
    "gold-hot": "hsl(var(--gold-hot))",
    "gold-text": "hsl(var(--gold-text))",
    "gold-edge": "hsl(var(--gold-edge))",
    "gold-ink": "hsl(var(--gold-ink))",
    "dock": "hsl(var(--dock))",
    "dock-ink": "hsl(var(--dock-ink))",
    "dock-muted": "hsl(var(--dock-muted))",
    "dock-on": "hsl(var(--dock-on))",
    "dock-rule": "hsl(var(--dock-rule))",
    "dock-line": "hsl(var(--dock-line))",
    "dock-badge": "hsl(var(--dock-badge))",
    "dock-badge-ink": "hsl(var(--dock-badge-ink))",
    "track": "hsl(var(--track))",
    "knob": "hsl(var(--knob))",
    "switch-on": "hsl(var(--switch-on))",
    "plant": "hsl(var(--plant))",
    "plant-2": "hsl(var(--plant-2))",
    "plant-pot": "hsl(var(--plant-pot))",
    "points-bg": "hsl(var(--points-bg))",
    "points-ink": "hsl(var(--points-ink))",
    "points-line": "hsl(var(--points-line))",
    "seg-line": "hsl(var(--seg-line))",
    "seg-on": "hsl(var(--seg-on))",
    "seg-on-ink": "hsl(var(--seg-on-ink))",
    "seg-off-ink": "hsl(var(--seg-off-ink))",
    "bulb-core": "hsl(var(--bulb-core))",
    "bulb-on": "hsl(var(--bulb-on))",
    "bulb-off": "hsl(var(--bulb-off))",
    "meter-fill": "hsl(var(--meter-fill))",
    "meter-fill-hot": "hsl(var(--meter-fill-hot))",
    "face-1": "hsl(var(--face-1))",
    "face-2": "hsl(var(--face-2))",
    "face-3": "hsl(var(--face-3))",
    "face-4": "hsl(var(--face-4))",
    "face-5": "hsl(var(--face-5))",
    "face-ink": "hsl(var(--face-ink))",
    "pulse-up": "hsl(var(--pulse-up))",
    "pulse-flat": "hsl(var(--pulse-flat))",
    "pulse-down": "hsl(var(--pulse-down))"
  }
};
